export default "__VITE_ASSET__Cd9WiW9K__"